export default __webpack_public_path__ + "6fb7afd398d3ddb36849dcc18bccf4c6.svg";